import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { IBaseSettings } from '$/types'

import { ISettingsState, IEventAttribute, IPopupNotification } from './types'

const initialState: ISettingsState = {
  baseSettings: [],
  eventAttributes: [],
  popupNotification: {
    isOpen: false,
    title: '',
    message: ''
  }
}

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setBaseSettings: (state, action: PayloadAction<IBaseSettings[]>) => {
      state.baseSettings = action.payload
    },
    setEventAttributes: (state, action: PayloadAction<IEventAttribute[]>) => {
      state.eventAttributes = action.payload
    },
    setPopupNotification: (
      state,
      action: PayloadAction<IPopupNotification>
    ) => {
      state.popupNotification = action.payload
    }
  }
})

export const {
  setBaseSettings: setBaseSettingsSync,
  setEventAttributes: setEventAttributesSync,
  setPopupNotification
} = settingsSlice.actions

export default settingsSlice.reducer
